module.exports = __webpack_public_path__ + "img/IMG_8909.251f0a96.jpg";